"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var compareNatural = function (value, other) {
    return (value || '').localeCompare(other || '', undefined, {
        numeric: true,
        sensitivity: 'base',
    });
};
exports.default = compareNatural;
